import React, { FunctionComponent } from 'react';
import { Text } from 'rebass/styled-components';
import styled from 'styled-components';
import theme from 'styled-theming';
import { Card } from '../card';
import { scrollBG, scrollThumbBG } from '../ScrollBox';

const borderColor = theme.variants('mode', 'variant', {
  default: {
    light: (props: any) => (props.theme.colors.greyLight),
    dark: 'rgba(255, 255, 255, 0.22)',
  },
  error: {
    light: (props: any) => props.theme.colors.red,
    dark: (props: any) => props.theme.colors.redLight,
  },
});

const textColor = theme('mode', {
  light: (props: any) => props.theme.colors.deepGrey,
  dark: (props: any) => props.theme.colors.isabelline,
});

const hoverBorderColor = theme('mode', {
  light: (props: any) => props.theme.colors.periwinkle,
  dark: (props: any) => props.theme.colors.brightCerulean,
});

const backgroundColor = theme('mode', {
  light: (props: any) => props.theme.colors.white,
  dark: (props: any) => props.theme.colors.lpGhost,
});

const StyledTextarea = styled.textarea`
  width: 100%;
  min-height: 155px;
  background-color: ${backgroundColor};
  color: ${textColor};
  border: 1px solid ${borderColor};
  border-radius: 3px;
  font-size: 13px;
  line-height: ${(props) => props.theme.lineHeights.copy};
  padding: 10px;
  resize: none;
  overflow-y: overlay;
  outline: none;
  &:focus {
    border: 1px solid ${hoverBorderColor};
  }
  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.02);
  }
  &::-webkit-scrollbar {
    width: 14px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${scrollThumbBG};
    outline: none;
    border-radius: 14px;

    &:hover {
      background-color: ${scrollBG};
    }
  }
`;

export interface FreeConditionProps {
  isEditing: boolean;
  condition: string;
  onChange: (condition: string) => void;
  placeholder: string;
}

const FreeCondition: FunctionComponent<FreeConditionProps> = ({
  isEditing, condition, onChange, placeholder,
}: FreeConditionProps) => {
  if (isEditing) {
    return (
      <StyledTextarea
        placeholder={placeholder}
        value={condition}
        readOnly={!isEditing}
        onChange={(ev) => {
          if (isEditing) {
            onChange(ev.target.value);
          }
        }}
        variant={condition?.trim().length === 0 ? 'error' : 'default'}
      />
    );
  }

  return (
    <Card p={3}><Text>{condition}</Text></Card>
  );
};

export default FreeCondition;
